<template>
  <component v-if="_config" :is="temp" />
</template>

<script>
export default {
  components: {
    defaultRedBag: () => import('@t/redbag/defaultRedbag'),
    yabocpRedBag: () => import('@t/redbag/yabocpRedbag')
  },
  computed: {
    _config() {
      return this.$store.state.app.appConfig
    },
    temp() {
      if (
        this._config.app_config.configValue.template &&
        this._config.app_config.configValue.template.redbag === 'newyaboLottery'
      ) {
        return 'yabocpRedBag'
      } else if (
        this._config.app_config.configValue.template &&
        this._config.app_config.configValue.template.redbag === 'dfcp'
      ) {
        return 'yabocpRedBag'
      } else if (
        this._config.app_config.configValue.template &&
        this._config.app_config.configValue.template.redbag === 'ks'
      ) {
        return 'yabocpRedBag'
      } else {
        return 'defaultRedBag'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
